import type { AppRouteProps } from "../types";
import { createRootRouteConfig } from "../utils/createRouteConfig";
import { agentsPageRouteConfig } from "./agents/config";
import { aiCasesRouteConfig } from "./ai-cases/config";
import { assistantsPageRouteConfig } from "./assistants/config";
import { casesPageRouteConfig } from "./cases/config";
import { chatbotPageRouteConfig } from "./chatbot/config";
import { classifierPageRouteConfig } from "./classification/config";
import { comparisonPageRouteConfig } from "./comparison/config";
import { databasePageRouteConfig } from "./database/config";
import { dialogsPageRouteConfig } from "./dialogs/config";
import { applicationsPageRouteConfig } from "./editor/config";
import { embeddingsPageRouteConfig } from "./embeddings/config";
import { extraAppsPageRouteConfig } from "./extraApp/config";
import { gitViewRouteConfig } from "./gitView/config";
import { meetingsPageRouteConfig } from "./meetings/config";
import { notFoundPageRouteConfig } from "./not-found/config";
import { pollsRouteConfig } from "./polls/config";
import { practicumPageRouteConfig } from "./practicum/config";
import { researchPageRouteConfig } from "./research/config";
import { schemasPageRouteConfig } from "./schemas/config";
import { skillsPageRouteConfig } from "./skills/config";
import { stylizationPageRouteConfig } from "./stylization/config";
import { userfilesPageRouteConfig } from "./userfiles/config";

export const allServiceRoutes: AppRouteProps[] = [
  agentsPageRouteConfig,
  applicationsPageRouteConfig,
  assistantsPageRouteConfig,
  aiCasesRouteConfig,
  casesPageRouteConfig,
  chatbotPageRouteConfig,
  embeddingsPageRouteConfig,
  classifierPageRouteConfig,
  comparisonPageRouteConfig,
  databasePageRouteConfig,
  dialogsPageRouteConfig,
  extraAppsPageRouteConfig,
  gitViewRouteConfig,
  userfilesPageRouteConfig,
  meetingsPageRouteConfig,
  practicumPageRouteConfig,
  pollsRouteConfig,
  researchPageRouteConfig,
  schemasPageRouteConfig,
  stylizationPageRouteConfig,
  skillsPageRouteConfig,
  notFoundPageRouteConfig,
];

export const routesArray = createRootRouteConfig(allServiceRoutes);
